import { render, staticRenderFns } from "./FileForm.vue?vue&type=template&id=a11c4fd2"
import script from "./FileForm.vue?vue&type=script&lang=js"
export * from "./FileForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports